import React from 'react';
import moment from 'moment';

type TimeAgoProps = {
  timestamp: string | Date;
  fallback?: string;
  className?: string;
};

const TimeAgo: React.FC<TimeAgoProps> = ({ timestamp, fallback = "Some time ago", className  }) => {
  const time = moment(timestamp);

  if (!time.isValid()) return <span>{fallback}</span>;

  return (
    <span className={className} title={time.format("MMMM Do YYYY, h:mm:ss a")}>
      {time.fromNow()}
    </span>
  );
};

export default TimeAgo;